var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "v-if": _vm.isInRole(["admin", "support", "analyst"]) } },
    [
      _c("toolbar"),
      _vm._v(" "),
      _c("zlick-navigation"),
      _vm._v(" "),
      _c(
        "v-container",
        { attrs: { fluid: "", "text-xs-center": "" } },
        [
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "500px" },
              model: {
                value: _vm.dialog,
                callback: function($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog"
              }
            },
            [
              _c(
                "v-form",
                { ref: "refundReasonForm", attrs: { "lazy-validation": "" } },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", "offset-xs0": "" } },
                            [
                              _c("h3", [
                                _vm._v(_vm._s(_vm.$t("refundDialogInfo")))
                              ]),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c("v-text-field", {
                                attrs: {
                                  "validate-on-blur": "",
                                  rules: [
                                    function(v) {
                                      return (
                                        !!v || _vm.$t("refundReason_required")
                                      )
                                    }
                                  ],
                                  required: ""
                                },
                                model: {
                                  value: _vm.refundReason,
                                  callback: function($$v) {
                                    _vm.refundReason = $$v
                                  },
                                  expression: "refundReason"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "blue darken-1", flat: "" },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.close($event)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("cancel")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "blue darken-1", flat: "" },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.deleteItem($event)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("refund")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.error
        ? _c(
            "v-container",
            { attrs: { fluid: "", "text-xs-center": "" } },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "", center: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", "offset-xs0": "" } },
                    [
                      _c(
                        "v-data-table",
                        {
                          staticClass: "elevation-1",
                          attrs: {
                            headers: _vm.headers,
                            items: _vm.items,
                            pagination: _vm.pagination,
                            "total-items": _vm.getTotalItems,
                            "hide-actions": ""
                          },
                          on: {
                            "update:pagination": function($event) {
                              _vm.pagination = $event
                            }
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "items",
                                fn: function(props) {
                                  return [
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [_vm._v(_vm._s(props.item._id))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatDate(props.item.createdAt)
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [_vm._v(_vm._s(props.item.phone))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [_vm._v(_vm._s(props.item.content))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatProductData(
                                              props.item.productData,
                                              "referenceName",
                                              "name"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [_vm._v(_vm._s(props.item.type))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatProductData(
                                              props.item.productData,
                                              "periodLenght"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            (props.item.amount / 100)
                                              .toLocaleString()
                                              .replace(".", ",")
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatAmount(
                                              props.item.serviceFee
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatAmount(
                                              props.item.grossAmount
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.formatAgent(props.item))
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [_vm._v(_vm._s(props.item.clientUserId))]
                                    ),
                                    _vm._v(" "),
                                    !_vm.isAnalyst()
                                      ? _c(
                                          "td",
                                          { staticClass: "text-xs-bottom" },
                                          [
                                            _vm.refund(props.item) ===
                                              "refund" &&
                                            !props.item.refundDisabled
                                              ? _c(
                                                  "v-btn",
                                                  {
                                                    staticClass: "mx-0",
                                                    attrs: { icon: "" }
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          color: "pink"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.showDeleteBox(
                                                              props.item
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("delete")]
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.refund(props.item) ===
                                            "refunded"
                                              ? _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "text-xs-center"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        props.item.refundReason
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.refund(props.item) ===
                                            "alreadyRefunded"
                                              ? _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "text-xs-center"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "alreadyRefunded"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.refund(props.item) === "failed"
                                              ? _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "text-xs-center"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("refundFailed")
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.refund(props.item) ===
                                            "manualRefund"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-xs-center"
                                                  },
                                                  [
                                                    !props.item.refundDisabled
                                                      ? _c(
                                                          "v-btn",
                                                          {
                                                            staticClass: "mx-0",
                                                            attrs: { icon: "" }
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  color: "pink"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.showDeleteBox(
                                                                      props.item
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [_vm._v("delete")]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            172439642
                          )
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "template",
                            { slot: "no-data" },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "primary" },
                                  on: { click: _vm.initialize }
                                },
                                [_vm._v(_vm._s(_vm.$t("reload")))]
                              )
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.error
        ? _c(
            "v-container",
            { attrs: { fluid: "", "text-xs-center": "" } },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "", center: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", "offset-xs0": "" } },
                    [
                      _c("v-pagination", {
                        attrs: { length: _vm.pagesCount },
                        on: {
                          input: function($event) {
                            return _vm.newPage(_vm.pagination.page)
                          }
                        },
                        model: {
                          value: _vm.pagination.page,
                          callback: function($$v) {
                            _vm.$set(_vm.pagination, "page", $$v)
                          },
                          expression: "pagination.page"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.error
        ? _c(
            "v-container",
            { attrs: { "grid-list-md": "" } },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "", center: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", "offset-xs4": "" } },
                    [
                      _c("v-text-field", {
                        attrs: { color: "error" },
                        domProps: { textContent: _vm._s(_vm.error) }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-77126b05", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77126b05","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Transactions.vue
// module id = null
// module chunks = 